import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-simple-tree-fold",
  "use": "app-icon-simple-tree-fold-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 17\" id=\"app-icon-simple-tree-fold\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M.5.5h16v16H.5z\" /><path d=\"M14 2a1 1 0 011 1v11a1 1 0 01-1 1H3a1 1 0 01-1-1V3a1 1 0 011-1h11zm0 1H3v11h11V3zM8.5 5a.5.5 0 01.5.5V8h2.5a.5.5 0 010 1H9v2.5a.5.5 0 01-1 0V9H5.5a.5.5 0 010-1H8V5.5a.5.5 0 01.5-.5z\" fill=\"#4D4D4D\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol